import React from "react";
import { useRecoilValue } from "recoil";

import { loadingAtom } from "./../../atoms/loading";
import Spinner from "./../../components/Spinner/Spinner";
import {
  AppBar,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  CssBaseline,
  Grid,
  Toolbar,
  Typography
} from '@mui/material';

import {
  MetricsDashboardStyled,
} from "./MetricsDashboard.Styles";

import { baseWhite, pine } from "./../../styleConstants";

import { ThemeProvider, createTheme } from '@mui/material/styles';

import WeeklySalesReports from './WeeklySalesReports';
import InteractionsToSell from './InteractionsToSell';
import RepMetrics from './RepMetrics';

let theme = createTheme({
  palette: {
      mode: 'light',        
      primary: {
        main: pine,
        contrastText: baseWhite,
      },
      secondary: { 
        main: pine,          
      },
      contrastThreshold: 3,
      tonalOffset: 0.2,
    },
});

const MetricsDashboard = (): React.JSX.Element => {
  const loading = useRecoilValue(loadingAtom);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <MetricsDashboardStyled id="main-container" data-testid="metrics-dashboard">
          <AppBar className={'app-bar'} position="fixed">
            <Toolbar className={'app-bar-toolbar'} variant="dense">
              <Typography variant='h5' color="secondary">
                  Metrics
              </Typography>
              <CardMedia className={'app-bar-logo'}
                    component="img"
                    image="data:image/svg+xml,<svg width=&quot;95&quot; height=&quot;32&quot; viewBox=&quot;0 0 95 32&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;>%0D%0A<path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M12.3741 22.8898C11.0716 24 9.57364 24.4898 7.97804 24.4898C5.63347 24.4898 3.41916 23.4449 2.01893 21.8122C0.781522 20.3755 0 18.4163 0 16.2612C0 11.5918 3.45172 8 7.75009 8C9.54108 8 11.1367 8.58776 12.3741 9.6V8.32653H16.4445V24.1633H12.3741V22.8898ZM4.23324 16.2612C4.23324 18.7428 6.02423 20.5714 8.40136 20.5714C9.99696 20.5714 11.3972 19.7877 12.2113 18.6122V13.8775C11.3321 12.702 9.93184 11.9183 8.30367 11.9183C5.82885 11.9183 4.23324 13.9755 4.23324 16.2612Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M22.9572 23.0531V32H18.7239V8.32653H22.7944V9.6C24.0318 8.58776 25.6274 8 27.4184 8C31.7167 8 35.1685 11.5918 35.1685 16.2612C35.1685 18.4163 34.4195 20.3755 33.1821 21.8122C31.7819 23.4449 29.535 24.4898 27.1904 24.4898C25.5948 24.4898 24.2271 24.0327 22.9572 23.0531ZM23.6085 18.6122C24.4225 19.7877 25.8228 20.5714 27.4184 20.5714C29.7955 20.5714 31.5865 18.7428 31.5865 16.2612C31.5865 13.9755 29.9909 11.9183 27.5161 11.9183C25.8879 11.9183 24.4877 12.702 23.6085 13.8775V18.6122Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path d=&quot;M45.719 24.4898C46.5331 24.4898 47.8031 24.3592 48.3567 24.1633L47.7054 20.5714C47.4123 20.6367 46.5982 20.7347 45.9795 20.7347C44.9375 20.7347 44.2537 20.4408 43.8304 19.951C43.4722 19.5265 43.3093 18.9388 43.3093 17.9592V11.9184H48.5195V8.32653H43.3093V3.91837H39.0761V8.32653H34.68V11.9184H39.0761V17.4694C39.0761 19.7224 39.4343 21.1265 40.2484 22.2041C41.323 23.6408 43.1791 24.4898 45.719 24.4898Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path d=&quot;M52.1015 5.42041C53.6319 5.42041 54.8694 4.2449 54.8694 2.7102C54.8694 1.17551 53.6319 0 52.1015 0C50.571 0 49.3336 1.17551 49.3336 2.7102C49.3336 4.2449 50.571 5.42041 52.1015 5.42041Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path d=&quot;M54.2181 24.1633V8.32653H49.9848V24.1633H54.2181Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path d=&quot;M64.9152 24.1633L72.1768 8.32653H67.7807L63.4498 17.9918L59.1189 8.32653H54.7228L61.9845 24.1633H64.9152Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M85.6092 21.649C84.0788 23.4776 81.5714 24.4898 79.1291 24.4898C74.4074 24.4898 70.858 21.2245 70.858 16.2612C70.858 11.8531 73.8538 8 78.543 8C82.9065 8 86 11.6898 86 16.098C86 16.5224 85.9674 16.9469 85.9023 17.3061H74.961C75.1889 19.5265 76.9799 21.0612 79.2268 21.0612C81.0178 21.0612 82.4506 20.049 83.1995 19.2327L85.6092 21.649ZM75.1563 14.2041H81.669C81.5388 12.8 80.2688 11.4286 78.5429 11.4286C76.7845 11.4286 75.3517 12.7674 75.1563 14.2041Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A<path d=&quot;M89.8296 13.0966V9.95171H91.4233C91.5511 9.95171 91.6904 9.98864 91.8409 10.0625C91.9915 10.1335 92.1193 10.2443 92.2244 10.3949C92.3324 10.5426 92.3864 10.7301 92.3864 10.9574C92.3864 11.1875 92.331 11.3835 92.2202 11.5455C92.1094 11.7045 91.9744 11.8253 91.8154 11.9077C91.6591 11.9901 91.5114 12.0313 91.3722 12.0313H90.2216V11.5199H91.1591C91.2529 11.5199 91.3537 11.473 91.4617 11.3793C91.5725 11.2855 91.6279 11.1449 91.6279 10.9574C91.6279 10.7642 91.5725 10.6335 91.4617 10.5653C91.3537 10.4972 91.2585 10.4631 91.1761 10.4631H90.5199V13.0966H89.8296ZM91.7301 11.6136L92.5142 13.0966H91.7557L90.9886 11.6136H91.7301ZM91.0227 14.9716C90.5511 14.9716 90.1094 14.8835 89.6975 14.7074C89.2855 14.5313 88.9233 14.2869 88.6108 13.9744C88.2983 13.6619 88.054 13.2997 87.8779 12.8878C87.7017 12.4759 87.6136 12.0341 87.6136 11.5625C87.6136 11.0909 87.7017 10.6492 87.8779 10.2372C88.054 9.82529 88.2983 9.46307 88.6108 9.15057C88.9233 8.83807 89.2855 8.59375 89.6975 8.41762C90.1094 8.24148 90.5511 8.15341 91.0227 8.15341C91.4943 8.15341 91.9361 8.24148 92.348 8.41762C92.76 8.59375 93.1222 8.83807 93.4347 9.15057C93.7472 9.46307 93.9915 9.82529 94.1676 10.2372C94.3438 10.6492 94.4318 11.0909 94.4318 11.5625C94.4318 12.0341 94.3438 12.4759 94.1676 12.8878C93.9915 13.2997 93.7472 13.6619 93.4347 13.9744C93.1222 14.2869 92.76 14.5313 92.348 14.7074C91.9361 14.8835 91.4943 14.9716 91.0227 14.9716ZM91.0227 14.1534C91.5 14.1534 91.9347 14.0369 92.3267 13.804C92.7188 13.571 93.0313 13.2585 93.2642 12.8665C93.4972 12.4744 93.6136 12.0398 93.6136 11.5625C93.6136 11.0852 93.4972 10.6506 93.2642 10.2585C93.0313 9.86648 92.7188 9.55398 92.3267 9.32103C91.9347 9.08807 91.5 8.97159 91.0227 8.97159C90.5455 8.97159 90.1108 9.08807 89.7188 9.32103C89.3267 9.55398 89.0142 9.86648 88.7813 10.2585C88.5483 10.6506 88.4318 11.0852 88.4318 11.5625C88.4318 12.0398 88.5483 12.4744 88.7813 12.8665C89.0142 13.2585 89.3267 13.571 89.7188 13.804C90.1108 14.0369 90.5455 14.1534 91.0227 14.1534Z&quot; fill=&quot;%23344C38&quot;/>%0D%0A</svg>%0D%0A"
                />
              </Toolbar>
          </AppBar>

          {loading && <Spinner overlay={true} />}

          <Grid container spacing={2} className={'main-container'}>

            {/* Weekly Sales Reports Card*/}
            <Grid item>
              <Card className={'card'}>
                <CardHeader
                  className='card-header'
                  title="Weekly Sales Reports"
                />
                <CardContent>
                  <WeeklySalesReports />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={'card'}>
                <CardHeader
                  className='card-header'
                  title="Interactions To Sell"
                />
                <CardContent>
                  <InteractionsToSell />
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={'card'}>
                <CardHeader
                  className='card-header'
                  title="Rep Metrics"
                />
                <CardContent>
                  <RepMetrics />
                </CardContent>
              </Card>
            </Grid>

          </Grid>
        </MetricsDashboardStyled>    
      </CssBaseline>
    </ThemeProvider>
  );
};

export default MetricsDashboard;
